module.exports = __webpack_public_path__ + "static/media/20180825_144002.5978db4d.jpg";